export function getAvailability(term) {
  const capacity = Number(term.capacity)
  const available = Number(term.available)

  if (
    !Number.isFinite(capacity) ||
    !Number.isFinite(available) ||
    capacity <= 0
  ) {
    return {
      label: 'Sprawdź dostępność',
      variant: 'unknown',
      bookingEnabled: false,
    }
  }

  const placesLeft = Math.max(
    0,
    Math.min(available, capacity)
  )

  const booked = capacity - placesLeft
  const occupancy = booked / capacity

  if (placesLeft === 0) {
    return {
      label: 'Brak miejsc',
      variant: 'sold-out',
      bookingEnabled: false,
    }
  }

  if (placesLeft === 1) {
    return {
      label: 'Ostatnie miejsce',
      variant: 'last-place',
      bookingEnabled: true,
    }
  }

  if (placesLeft <= 3 || occupancy >= 0.85) {
    return {
      label: `Ostatnie ${placesLeft} miejsca`,
      variant: 'last-places',
      bookingEnabled: true,
    }
  }

  return {
    label: 'Dostępne miejsca',
    variant: 'available',
    bookingEnabled: true,
  }
}